import { LocationDirection, Side, TranslateFunction } from "../../models/Common"
import { ISolution } from "../../models/Solution"
import {
  BaseComponent,
  IComponentInfo,
  IComponentLabels,
  IComponentShape,
} from "../Base"

export class ExtraLayer extends BaseComponent {
  public constructor(
    thickness: number,
    id: number,
    solution: ISolution,
    centralOffsetX: number,
    centralOffsetY: number,
    prevLayerW: number,
    t: TranslateFunction
  ) {
    const description =
      t("d_prot_layer") +
      ": " +
      (solution.customization.otherSettings.UV
        ? t("d_prot_layer_UV") + ", "
        : "") +
      (solution.customization.otherSettings.IR
        ? t("d_prot_layer_IR") + ", "
        : "") +
      (solution.customization.otherSettings.PF
        ? t("d_prot_layer_PF") + ", "
        : "") +
      `${thickness} mm`

    super(
      {
        id,
        color: "#7d37c0",
        description: description,
      } as IComponentInfo,
      {
        width: prevLayerW,
        height: thickness,
        centralOffsetX: centralOffsetX,
        centralOffsetY: centralOffsetY + thickness / 2,
      } as IComponentShape, // overall shape
      {
        dimensions: {
          sides: [Side.Right],
          diff: false,
        },
        id: {
          locationDirection: LocationDirection.Outward,
          fromSide: Side.Left,
          padding: 20,
        },
        description: false,
      } as IComponentLabels
    )
  }
}
